module.exports = __webpack_public_path__ + "img/higienico-mobile.740d0d05.png";